import React, { createContext, useContext, useState, useEffect } from 'react';
import client from '../api/client';
// import { useUser } from './UserContext';
const BlogContext = createContext();
const BlogProvider = ({ children }) => {
	// 	const [titles, setTitles] = useState([]);
	// 	const [loading, setLoading] = useState(false);
	// 	const fetchData = async () => {
	// 		try {
	// 			setLoading(true);
	// 			const titles = await client.get('/blog/archive');
	// 			setTitles(titles.data.titles);
	// 			setLoading(false);
	// 		} catch (error) {
	// 			setLoading(false);
	// 			return console.error(error);
	// 		}
	// 	};
	//
	// 	useEffect(() => {
	// 		fetchData();
	// 	}, []);

	if (!children) return console.log('no children');
	return (
		<BlogContext.Provider
			value={
				{
					/*titles, loading*/
				}
			}
		>
			{children}
		</BlogContext.Provider>
	);
};
export const useBlog = () => useContext(BlogContext);
export default BlogProvider;
